import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { handleSendGeneric } from 'services/generic';
import { convertBrl } from 'utility/generic';

export const ModalDebtor = (args) => {
  const [modal, setModal] = useState(false);
  const [value, setValue] = useState(0);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    async function getDebtorByClient() {
      const data = await handleSendGeneric(
        `/v1/client/debtor/` + args.data.id,
        'GET'
      );
      if (data !== undefined) {
        setValue(convertBrl(data));
      }
    }

    getDebtorByClient();
  }, [args.data.id]);

  return (
    <div>
      <Button
        color='danger'
        onClick={toggle}
        size='lg'
        style={{ whiteSpace: 'nowrap' }}
        block
      >
        Saldo
      </Button>
      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalBody
          style={{
            justifyContent: 'center',
            marginTop: '10%',
            display: 'flex',
          }}
        >{`Saldo devedor de ${value}`}</ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={toggle}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
